/* eslint-disable @tanstack/query/exhaustive-deps --
   `dataApi` is used only by `queryFn` and must stay out of the query key.
   PlatformDataApi contains a circular Auth0 client, which breaks key
   serialization.*/
import { queryOptions } from "@tanstack/react-query";

import { ISharedDataApi } from "../types";
import type { RadiatorCurve } from "../types/radiator-curve.model";

export const getRadiatorCurvesBySubstationOptions = (
  substationUid: string,
  propAiApi: ISharedDataApi | null
) =>
  queryOptions<RadiatorCurve[]>({
    queryKey: ["radiator-curves", "substation", substationUid],
    queryFn: async () => {
      if (!propAiApi) {
        console.warn("PropAI API not available for substation curves");
        return [];
      }
      try {
        return await propAiApi.getRadiatorCurvesBySubstation(substationUid);
      } catch (error) {
        console.error("Failed to fetch radiator curves by substation", error);
        return [];
      }
    },
    enabled: !!(substationUid && propAiApi),
  });

export const getRadiatorCurveByFlexstationOptions = (
  substationUid: string,
  flexstationUid: string,
  propAiApi: ISharedDataApi | null
) =>
  queryOptions<RadiatorCurve | null>({
    queryKey: ["radiator-curve", "flexstation", substationUid, flexstationUid],
    queryFn: async () => {
      if (!propAiApi) {
        console.warn("PropAI API not available for flexstation curve");
        return null;
      }
      try {
        return await propAiApi.getRadiatorCurveByFlexstation(substationUid, flexstationUid);
      } catch (error) {
        console.error("Failed to fetch radiator curve by flexstation", error);
        return null;
      }
    },
    enabled: !!(substationUid && flexstationUid && propAiApi),
  });
